jQuery(document).foundation();

jQuery(function($){
    // スムーズスクロール
    /*$('a[href^="#"]').on('click', function () {
        var speed = 800;
        var href = $(this).attr('href');
        var target = $(href == '#' || href == '' ? 'html' : href);
        var position = 0;
        if(target == '#topbar-center-logo') {
        position = 0;
        }else{
        position = target.offset().top - 120;
        }
        console.log(position);
        $('body,html').animate({ scrollTop: position }, speed, 'swing');
        return false;
    });*/
    
    var urlHash = location.hash;
      if (urlHash) {
        $('body,html').stop().scrollTop(0);
        setTimeout(function(){
          // ヘッダー固定の場合はヘッダーの高さを数値で入れる、固定でない場合は0
          var headerHight = 130;
          var target = $(urlHash);
          var position = target.offset().top - headerHight;
          $('body,html').stop().animate({scrollTop:position}, 400);
      }, 100);
      }
    
    // トップへ戻る
    /*var $topBtn = $('#toTop');
    $('#toTop').hide();
    var footerheight = $(window).on('scroll', function () {
        if ($(this).scrollTop() > 300) {
            $topBtn.fadeIn();
            $('.top-bar').addClass('stickon');
        } else {
            $topBtn.fadeOut();
            $('.top-bar').removeClass('stickon');
        }
        scrollHeight = $(document).height();
        scrollPosition = $(window).height() + $(this).scrollTop();
        footHeight = $('.footer').innerHeight();
        if (scrollHeight - scrollPosition <= footHeight) {
            $('#toTop').removeClass('fix');
        } else {
            $('#toTop').addClass('fix');
        }
    });
    */
    $('.search-icon').on('click', function(evt){
        var container = $('.search-wrapper');
        if(!container.hasClass('active')){
            container.addClass('active');
            evt.preventDefault();
        }else if(container.hasClass('active')){
            container.removeClass('active');
            // clear input
            container.find('.search-input').val('');
        }
    });
    
    $('.news-block').on('click', function(){
        var reg = new RegExp("^(https?:)?\/\/"+document.domain);
        var linkurl = $(this).find(".bt > a").attr("href");
        if (linkurl.match(reg) || linkurl.charAt(0) === "/") {
        window.location = linkurl;
        return false;
        }else{
            open(linkurl, "_blank" );
        }
    });
    $(window).on("scroll", function () {
        const sliderHeight = 46;
        if (sliderHeight < $(this).scrollTop()) {
          $(".top-bar-wrapper").addClass("headerScroll");
        } else {
          $(".top-bar-wrapper").removeClass("headerScroll");
        }
      });
      $('.orbit').on("touchstart", start_check);
      $(".orbit").on("touchmove", move_check);
      $(".orbit").on("touchend", end_check);
});

var moveY,moveX, posiY, posiX;
function start_check(event) 
{
    /** 現在の座標取得 */
    posiY = getY(event);
    posiX = getX(event);

    /** 移動距離状態を初期化 */
    moveY = '';
    moveX = '';

    /** 表示メッセージを初期化 */
    msgY = '';
    msgX = '';
}

function move_check(event)
{
    if (posiX - getX(event) > 70) // 70px以上移動でスワイプと判断
    {
        /** 右→左と判断 */
        moveX = "left";
    }
    else if (posiX - getX(event) < -70)  // 70px以上移動でスワイプと判断
    {
        /** 左→右と判断 */			
        moveX = "right";
    }
}

function end_check(event)
{
    if (moveX == "left")
    {
        msgX = "左へ移動";
        jQuery('.orbit-next').click();
    }
    else if (moveX == "right")
    {
        msgX = "右へ移動";
        jQuery('.orbit-previous').click();
    }
    else
    {
        msgX = "移動なし";
    }

    //console.log("（横移動）"+msgX+":"+"（縦移動）"+msgY);

}

// 座標取得処理
function getY(event) 
{
    //縦方向の座標を取得
    return (event.originalEvent.touches[0].pageY);
}

function getX(event) 
{
    //横方向の座標を取得
    return (event.originalEvent.touches[0].pageX);
}